import { ReportPrinter } from "./ReportPrinter";
import { PageData } from "./usePrintJourneyListData";

export function printComments(printer: ReportPrinter, page: PageData) {
  if (page.comments.length > 0) {
    const lineHeight = 12;
    const commentMiddle = 95;
    const underlineOffset = 3;
    const offsetRight = 25;
    const maxWidth = 215;

    printer.withFont(
      () => {
        let totalHeight = 0;
        for (const line of page.comments) {
          const dims = printer.getDimensions(line, {
            maxWidth: maxWidth,
          });
          totalHeight += dims.h;
        }

        let currentLine = Math.round(
          commentMiddle - totalHeight / 2 + lineHeight * 0.75
        );

        for (const comment of page.comments) {
          const tsize = printer.printTextExt(
            comment,
            printer.printableWidth + printer.pageMarginX - offsetRight,
            currentLine,
            maxWidth,
            { align: "right", maxWidth: maxWidth }
          );

          let currentLinePos = currentLine;
          while (currentLinePos < currentLine + tsize.height) {
            printer.doc.line(
              printer.printableWidth + printer.pageMarginX - (offsetRight - 2),
              currentLinePos + underlineOffset,
              printer.printableWidth +
              printer.pageMarginX -
              (offsetRight + 2) -
              tsize.width,
              currentLinePos + underlineOffset
            );
            currentLinePos += lineHeight * 1.5;
          }

          currentLine += tsize.height;
        }
      },
      "slab-normal",
      lineHeight,
      1.5
    );
  }
}
